module.exports = __webpack_public_path__ + "static/media/sabine-schmitt.d54cc995.jpg";